export default {
    fields: {
        apiData: {
            "id": 53603,
            "titleUrl": "magnum220",
            "title": "Magnum™ 220",
            "formattedTitle": null,
            "description": "With the industry's largest cab featuring a choice of ergonomically designed packages and 360-degree visibility, long working days won't seem so long in the Magnum™ 220.",
            "icon": null,
            "bigthumbnail": "https://corporatei-avanade.stylelabs.io/api/public/content/0f933d17d71f4e8485c8c49ea040923c?v=3cac78e1",
            "bigthumbnailAlt": null,
            "thumbnail": "https://corporatei-avanade.stylelabs.io/api/public/content/0f933d17d71f4e8485c8c49ea040923c?v=3cac78e1",
            "thumbnailAlt": null,
            "full": "https://corporatei-avanade.stylelabs.io/api/public/content/0f933d17d71f4e8485c8c49ea040923c?v=3cac78e1",
            "fullAlt": null
        }
    }
}